var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"welcome"},[_c('h4',[_c('span',[_vm._v(_vm._s(_vm.msg))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }